import { initializeApp, getApps } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const apiKey = (process.env.REACT_APP_FIREBASE_API_KEY || '').trim();
const authDomain = (process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '').trim();
const databaseURL = (process.env.REACT_APP_FIREBASE_DATABASE_URL || '').trim();
const projectId = (process.env.REACT_APP_FIREBASE_PROJECT_ID || '').trim();
const storageBucket = (process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '').trim();
const messagingSenderId = (process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '').trim();
const appId = (process.env.REACT_APP_FIREBASE_APP_ID || '').trim();
const measurementId = (process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || '').trim();

/** True when Firebase app + Realtime Database URL are configured (no Firebase Auth used). */
export function isFirebasePickStatsConfigured() {
  return Boolean(apiKey && authDomain && databaseURL && projectId && appId);
}

let app;
let db;

if (isFirebasePickStatsConfigured()) {
  const config = {
    apiKey,
    authDomain,
    databaseURL,
    projectId,
    appId,
  };
  if (storageBucket) config.storageBucket = storageBucket;
  if (messagingSenderId) config.messagingSenderId = messagingSenderId;
  if (measurementId) config.measurementId = measurementId;

  app = getApps().length ? getApps()[0] : initializeApp(config);
  db = getDatabase(app);
}

export function getFirebaseDb() {
  return db || null;
}
